import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "@/App";
import "@/i18n/i18n";
import "@/index.css";
import * as Sentry from "@sentry/react";
import { URLS } from "@/constants/urls";
import { Home } from "@/pages/Home";
import { PaymentStatus } from "@/pages/PaymentStatus";
import { Summary } from "@/pages/Summary";

const router = createBrowserRouter([
  {
    path: "",
    element: <App />,
    children: [
      {
        path: URLS.HOME,
        element: <Home />,
      },
      {
        path: URLS.SUMMARY,
        element: <Summary />,
      },
      {
        path: URLS.PAYMENT_SUCCESS,
        element: <PaymentStatus status="success" />,
      },
      {
        path: URLS.PAYMENT_CANCEL,
        element: <PaymentStatus status="error" />,
      },
      {
        path: "*",
        element: <div>404 Not Found</div>,
      },
    ],
  },
]);

Sentry.init({
  dsn: "https://c9ba6279266bd885cd07a4649c11b434@o4509045752987648.ingest.de.sentry.io/4511467636785232",
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["https://api.kalkulator.quickersim.com/"],
  enableLogs: true,
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
